import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=20c7f5c8&scoped=true&"
import script from "./Finished.js?vue&type=script&lang=js&"
export * from "./Finished.js?vue&type=script&lang=js&"
import style0 from "./Finished.scss?vue&type=style&index=0&id=20c7f5c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7f5c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
